// クリップボードに保存する
const UseCopyClipboard = (props)=>{
    // コピー対象のテキストを選択する
    props.select();
    // 選択しているテキストをクリップボードにコピーする
    document.execCommand("Copy");
}
export default UseCopyClipboard
